<iframe
  *ngIf="url"
  class="iframe"
  [attr.src]="url | safe: 'url'"
  (load)="iframeLoad.emit()"
>
</iframe>
